// CookieBanner.tsx
import { useState, useEffect } from 'react'
import { useCookies } from 'react-cookie'
import { Snackbar, Button } from '@mui/material'
import colors from 'theme/colors'

export function CookieBanner() {
  const [cookies, setCookie] = useCookies(['cookies-accepted'])
  const [open, setOpen] = useState(false)

  useEffect(() => {
    // Check if the consent cookie already exists
    if (typeof cookies['cookies-accepted'] === 'undefined') {
      setOpen(true)
    }
  }, [cookies])

  const handleAccept = () => {
    // Set the cookies-accepted cookie for 365 days
    setCookie('cookies-accepted', 'true', { path: '/', maxAge: 365 * 24 * 60 * 60 })
    setOpen(false)
  }

  return (
    <Snackbar
      open={open}
      onClose={() => setOpen(false)}
      autoHideDuration={null} // Keeps the banner open until the user accepts
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      action={
        <Button color='primary' size='small' onClick={handleAccept}>
          OK
        </Button>
      }
      message={
        <span>
          Auf digitaldaten.wuppertal.de verwenden wir ausschließlich technisch notwendige Cookies sowie das
          Webanalysetool Matomo zur anonymisierten statistischen Auswertung. Ihre Einwilligung können Sie jederzeit in
          den <a href='/einstellungen'>Einstellungen</a> widerrufen. Weitere Informationen und Hinweise finden Sie in
          der Datenschutzerklärung.
        </span>
      }
      ContentProps={{
        sx: {
          backgroundColor: '#000000',
          color: colors.textDark,
          border: '1px solid',
          borderColor: colors.colorDetail,
        },
      }}
    />
  )
}

export default CookieBanner
